import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import BlockSwipeable from './BlockSwipeable';

const Slider = styled(Grid)`
  width: 100%;
  flex-grow: 1;
  text-align: center;
  height: 100%;
`;

const BlockSlide = ({ images, activeStep, handleStepChange }) => {
  return (
    <Slider container direction="column" justify="center" wrap="nowrap">
      <BlockSwipeable
        activeStep={activeStep}
        images={images}
        handleStepChange={handleStepChange}
      />
    </Slider>
  );
};
export default BlockSlide;
